/* tslint:disable */
/* eslint-disable */
/**
 * Y-sports-Core API
 * API for managing Y-sports related stuff
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TeamMeta
 */
export interface TeamMeta {
    /**
     * 
     * @type {string}
     * @memberof TeamMeta
     */
    creator?: string;
    /**
     * 
     * @type {Date}
     * @memberof TeamMeta
     */
    creationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TeamMeta
     */
    description?: string;
}

/**
 * Check if a given object implements the TeamMeta interface.
 */
export function instanceOfTeamMeta(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TeamMetaFromJSON(json: any): TeamMeta {
    return TeamMetaFromJSONTyped(json, false);
}

export function TeamMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): TeamMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'creator': !exists(json, 'creator') ? undefined : json['creator'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (new Date(json['creationDate'])),
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function TeamMetaToJSON(value?: TeamMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'creator': value.creator,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate.toISOString()),
        'description': value.description,
    };
}

